//
// Copyright 2025 DXOS.org
//

import { Config2 } from '@dxos/app-framework/config';

export default Config2.make({
  plugin: {
    key: 'org.dxos.plugin.settings',
    name: 'Settings',
    author: 'DXOS',
    tags: ['system'],
  },
});
